import React, { useEffect, useState } from 'react';
import QRCode from 'qrcode';
import { remoteJoinUrl } from '../../utils/voteRemote';

/**
 * QR + short code for phones to join the voting remote.
 */
export default function JoinQrCard({ joinCode, className = '' }) {
  const [dataUrl, setDataUrl] = useState('');
  const url = joinCode ? remoteJoinUrl(joinCode) : '';

  useEffect(() => {
    let cancelled = false;
    if (!url) {
      setDataUrl('');
      return undefined;
    }
    QRCode.toDataURL(url, {
      width: 180,
      margin: 1,
      color: { dark: '#1a1a1a', light: '#ffffff' },
    })
      .then((d) => {
        if (!cancelled) setDataUrl(d);
      })
      .catch(() => {
        if (!cancelled) setDataUrl('');
      });
    return () => {
      cancelled = true;
    };
  }, [url]);

  if (!joinCode) return null;

  return (
    <div
      className={`flex items-center gap-3 rounded-xl border border-slate-200 bg-white/95 p-3 shadow-sm ${className}`}
    >
      {dataUrl ? (
        <img src={dataUrl} alt={`QR code to join voting room ${joinCode}`} className="h-24 w-24 shrink-0" />
      ) : (
        <div className="flex h-24 w-24 shrink-0 items-center justify-center bg-slate-100 text-xs text-slate-500">
          QR…
        </div>
      )}
      <div className="min-w-0">
        <div className="text-[10px] font-semibold uppercase tracking-wide text-slate-500">
          Scan to vote
        </div>
        <div className="font-mono text-2xl font-bold tracking-widest text-slate-900">{joinCode}</div>
        <div className="truncate text-[11px] text-slate-500">{url.replace(/^https?:\/\//, '')}</div>
      </div>
    </div>
  );
}
